
export default {
  props: {
    blog: Object,
  },
};
